export default {
  title: "Passionate Riichi, Ultra-Intense Showdown",
  game_title:
    "『雀夢麻雀-じゃんゆめ』は、全3D超激熱な麻雀プラットフォームです。今すぐリーチ麻雀の旅を始めましょう。",
  game_title1:
    "あなたは隊長として超能力雀士を率いて異世界麻雀大会に挑み、最強チームの栄光をかけて戦います。",
  header: {
    Menu: ["ホーム", "キャラクター", "フォローする"],
  },
  role_title: "キャラクター",
  rolt: [
    {
      name: "マルゴー",
      desc: "純情で無口のないメイド<br/>高難易度ダンスの挑戦者",
    },
    {
      name: "小野原まどか",
      desc: "元気な麻雀少女<br/>たこ焼き爆食マスター",
    },
    { name: "ロキラ", desc: "超人気マジシャン<br/>彼女に道具扱いされないように注意" },
    { name: "蘭若", desc: "ミステリアスな雀荘のオーナー<br/>特技は琵琶の背弾き" },
    { name: "ヘルモー", desc: "元eスポーツ選手'<br/>'愛するものに全力を注ぐ" },
    { name: "霧島綾月", desc: "? ? ? ? ?<br/> ? ? ?" },
  ],
  "people": {
    "names": ["マルゴー", "小野原まどか", "ロキラ", "蘭若", "ヘルモー", "霧島綾月","ホアジャオ","セリア","イブ","ユーリン","????","????"],
    "descs": [
      "純情で無口のないメイド<br/>高難易度ダンスの挑戦者",
      "元気な麻雀少女<br/>たこ焼き爆食マスター",
      "超人気マジシャン<br/>彼女に道具扱いされないように注意",
      "ミステリアスな雀荘のオーナー<br/>特技は琵琶の背弾き",
      "元eスポーツ選手<br/>愛するものに全力を注ぐ",
      "由緒正しい神社の巫女<br/>君との終らぬ縁紡ぐ",
      "川味食府の看板シェフ<br/>熱い豆腐はゆっくり味わわなきゃ",
      "ナルシストな賞金稼ぎ魔女<br/>★5評価、わすれずヨロシクね",
      " 天然系聖樹エルフ<br/> おふろ大好き＝元気の秘訣",
      "ダウナー系の新星格闘家<br/>お茶と猫を片手に、気怠く勝負に挑む！",
      "? ? ? ? ? ? ?<br/>? ? ?",
      "? ? ? ? ? ? ?<br/>? ? ?",
    ]
  },
  "footer_list": ['サービス規約', 'プライバシーポリシー']

};
